import { ConnectedAccountCurrencyConversionStatus } from '@40seas/entities/connected-accounts';
import { EnumColor } from '@40seas/frontend/common/providers';

export const ConnectedAccountCurrencyConversionStatusMapping = {
    [ConnectedAccountCurrencyConversionStatus.Settled]: 'success',
    [ConnectedAccountCurrencyConversionStatus.Cancelled]: 'error',
    [ConnectedAccountCurrencyConversionStatus.InProgress]: 'info',
    [ConnectedAccountCurrencyConversionStatus.Pending]: 'primary',
    [ConnectedAccountCurrencyConversionStatus.Blocked]: 'secondary',
    [ConnectedAccountCurrencyConversionStatus.Overdue]: 'warning',
} as { [key in ConnectedAccountCurrencyConversionStatus]: EnumColor };
